export const splitDurationMinutes = (minutes) => {
    const total = Math.max(Number(minutes) || 0, 0);
    const days = Math.floor(total / 1440);
    const hours = Math.floor((total % 1440) / 60);
    const remainingMinutes = total % 60;

    return {
        days,
        hours,
        minutes: remainingMinutes
    };
};

export const combineDurationParts = ({ days = 0, hours = 0, minutes = 0 }) => (
    (Math.max(Number(days) || 0, 0) * 1440)
    + (Math.max(Number(hours) || 0, 0) * 60)
    + Math.max(Number(minutes) || 0, 0)
);

export const formatDuration = (minutes) => {
    const parts = splitDurationMinutes(minutes);
    const output = [];

    if (parts.days) output.push(`${parts.days} ${parts.days === 1 ? 'day' : 'days'}`);
    if (parts.hours) output.push(`${parts.hours} ${parts.hours === 1 ? 'hour' : 'hours'}`);
    if (parts.minutes) output.push(`${parts.minutes} ${parts.minutes === 1 ? 'minute' : 'minutes'}`);

    return output.length ? output.join(' ') : '0 minutes';
};
